module.exports = __webpack_public_path__ + "static/media/twinkle-color-05.bc5a1bae.png";